import React from "react";
import "./Footer.css";
import Logo from "../../assests/logo.jpeg";
import { Link } from "react-router-dom";
import Google from "../../assests/GoogleImg.png";
import Apple from "../../assests/AppleImg.png";
import { ROUTES } from "../../config/routes";

function Footer2() {
  return (
    <div className="MainFooter">
      <div className="FooterContainer">
        <div className="footer-title">ISCB</div>
        <div className="logoFooter">
          <img src={Logo} alt="" />
        </div>
        <div className="usefullinks">
          <h3>Useful links</h3>
          <div className="Linksfooter">
            <Link to={ROUTES.iscb}>
              <li className="pb-3">ISCB</li>
            </Link>
            <Link to={ROUTES.camps}>
              <li className="pb-3">Camps </li>
            </Link>
            <Link to={ROUTES.about}>
              <li className="pb-3">About Us</li>
            </Link>
            <Link to={ROUTES.terms}>
              <li className="pb-3">Terms and Conditions</li>
            </Link>
            <Link to={ROUTES.privacy}>
              <li className="pb-3">Privacy Policy</li>
            </Link>
            <Link to={ROUTES.refundPolicy}>
              <li className="pb-3">Pricing and Refund Policy</li>
            </Link>
          </div>
        </div>
        <div className="address">
          <h3>Working Address</h3>
          <p>
            Address: 3-6-475/Kalpavruksha, Himayatnagar,Hyderabad,
            <br /> Telangana, India -500029
            <br />
            Phone: +91 9676594595
            <br />
            Phone: +91 9000199377
            <br />
            Email: Iscbtalent@gmail.com <br/>
              Email: Iscbnetwork@gmail.com
          </p>
        </div>

        <div className="social-links">
          <h3 className="pb-3"> Connect with us </h3>
          <div className="rounded-social-buttons">
            <a
              className="social-button facebook"
              href="https://www.facebook.com/people/ISCB-Indian-Schools-Board-for-Cricket/100092425016922/"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fab fa-facebook-f"></i>
            </a>
            <a
              className="social-button twitter"
              href="https://twitter.com/ISCBCricket"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fab fa-twitter"></i>
            </a>
            <a
              className="social-button youtube"
              href="https://www.youtube.com/@ISCBIndianSchoolsBoardforCrick"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fab fa-youtube"></i>
            </a>
            <a
              className="social-button instagram"
              href="https://www.instagram.com/ISCBschoolsworldcup"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fab fa-instagram instaIcon"></i>
            </a>
          </div>
          <div className="download-links-ft">
            <h3 className="pb-3"> Download ISCB App </h3>
            <div className="Down-app-links-footer">
              <a href="https://apps.apple.com/us/app/ISCB/id6448773651" target="_blank" rel="noreferrer">
                <img src={Apple} alt="ISCB app download apple store" />
              </a>
              <a
                href=" https://play.google.com/store/apps/details?id=com.ISCB.cricket&hl=en-IN"
                target="_blank"
                rel="noreferrer"
              >
                <img src={Google} alt="ISCB app download play store" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="Copyrights">
        <p> Copyright © 2023 ISCB. All rights reserved.</p>
      </div>
    </div>
  );
}

export default Footer2;
